// extracted by mini-css-extract-plugin
module.exports = {"pointNumberWrapper":"CustomSlider_pointNumberWrapper__2y1ud","pointNumber":"CustomSlider_pointNumber__2MnAn","customSlider":"CustomSlider_customSlider__1G9iL"};